var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", xl12: "", "pa-2": "" } },
        [
          _c(
            "v-card",
            [
              _c("Subheader", { attrs: { title: "Populate RISC grades" } }),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "info",
                        value: true,
                        outline: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Populate the RISC grades and output configurations for the tenant. \n          "
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "add" },
                          on: {
                            click: function ($event) {
                              return _vm.populateValues()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("add"),
                          ]),
                          _vm._v("\n          Populate\n        "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", xl6: "", "pa-2": "" } },
        [
          _c(
            "v-card",
            { attrs: { "pb-2": "" } },
            [
              _c(
                "Subheader",
                {
                  attrs: {
                    title: "Qualifier Values",
                    search: "Qualifier Values",
                  },
                  model: {
                    value: _vm.searchValue,
                    callback: function ($$v) {
                      _vm.searchValue = $$v
                    },
                    expression: "searchValue",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "add" },
                      on: {
                        click: function ($event) {
                          return _vm.addValue()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Add")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "info",
                        value: true,
                        outline: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Record continuous database data qualifier values that should be displayed. Any data qualifier values not included in this list will not be shown to the client. Once a continuous database data qualifier is recorded in this list, you can map the value to an output value in the "
                      ),
                      _c("code", [_vm._v("RISC Grade Output Configuration")]),
                      _vm._v(" table.\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.valueHeaders,
                      items: _vm.ContinuousDataQualifiers,
                      search: _vm.searchValue,
                      "hide-actions": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "headerCell",
                        fn: function (props) {
                          return [
                            props.header.showtooltip
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "span",
                                                _vm._g(
                                                  {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        props.header.text
                                                      ),
                                                    },
                                                  },
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("v-card-text", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ContinuousDataQualifiersManage.menuTextYes"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("v-card-text", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "ContinuousDataQualifiersManage.menuTextNo"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _c("span", [_vm._v(_vm._s(props.header.text))]),
                          ]
                        },
                      },
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.QualifierValue)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              props.item.ShouldFilter
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            disabled: "",
                                            outline: "",
                                            small: "",
                                            color: "error",
                                          },
                                        },
                                        [_vm._v("filtered out")]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    [
                                      !_vm.haveConfiguration(props.item)
                                        ? _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                disabled: "",
                                                outline: "",
                                                small: "",
                                                color: "warning",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "output configuration needed"
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                disabled: "",
                                                outline: "",
                                                small: "",
                                                color: "info",
                                              },
                                            },
                                            [_vm._v("-")]
                                          ),
                                    ],
                                    1
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-right" }, [
                              _vm._v(_vm._s(props.item.Level)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-right" },
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "EditButton",
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editValue(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.Edit")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "DeleteButton",
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteValue(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.Delete")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", xl6: "", "pa-2": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "Subheader",
                {
                  attrs: {
                    title: "RISC Grade Output Configuration",
                    search: "RISC Grade Output Configuration",
                  },
                  model: {
                    value: _vm.searchOutput,
                    callback: function ($$v) {
                      _vm.searchOutput = $$v
                    },
                    expression: "searchOutput",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "add" },
                      on: {
                        click: function ($event) {
                          return _vm.addOutput()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Button.Add")) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        color: "info",
                        icon: "info",
                        value: true,
                        outline: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Designate client-facing data qualifier output values. Each output value can be mapped to multiple continuous database data qualifier value. Once mapped, the continuous database qualifier value will be translated to the code and description specified in this table in output reports and R client.\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.outputHeaders,
                      items: _vm.ContinuousDataQualifierConfigurations,
                      search: _vm.searchOutput,
                      "hide-actions": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.Code)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.Description)),
                            ]),
                            _vm._v(" "),
                            _c("td", {
                              staticClass: "text-xs-left",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm
                                    .getValueString(
                                      props.item.ContinuousDataQualifiers
                                    )
                                    .toString()
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.Ordinal)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-right" },
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "EditButton",
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editOutput(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.Edit")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "DeleteButton",
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteOutput(props.item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("Button.Delete")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n      Add Qualifier Value\n    ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-form",
                  {
                    ref: "formValue",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.validValue,
                      callback: function ($$v) {
                        _vm.validValue = $$v
                      },
                      expression: "validValue",
                    },
                  },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Qualifier Value" },
                      model: {
                        value: _vm.addQualifierValue.QualifierValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierValue, "QualifierValue", $$v)
                        },
                        expression: "addQualifierValue.QualifierValue",
                      },
                    }),
                    _vm._v("\n        Should Filter out:\n        "),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": "",
                          "open-on-hover": "",
                          "open-delay": 400,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    {
                                      staticClass: "clickable ml-2",
                                      attrs: { small: "", color: "primary" },
                                    },
                                    on
                                  ),
                                  [_vm._v("info_outline")]
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-card",
                          [
                            _c("v-card-text", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ContinuousDataQualifiersManage.menuTextYes"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-card-text", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "ContinuousDataQualifiersManage.menuTextNo"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-switch", {
                      attrs: {
                        "hide-details": "",
                        label: `${_vm
                          .getFilterString(_vm.addQualifierValue.ShouldFilter)
                          .toString()}`,
                      },
                      model: {
                        value: _vm.addQualifierValue.ShouldFilter,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierValue, "ShouldFilter", $$v)
                        },
                        expression: "addQualifierValue.ShouldFilter",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Level", rules: _vm.qualifierValueRule },
                      model: {
                        value: _vm.addQualifierValue.Level,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierValue, "Level", $$v)
                        },
                        expression: "addQualifierValue.Level",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.submitAddValue()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.addValueModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addValueModal,
          callback: function ($$v) {
            _vm.addValueModal = $$v
          },
          expression: "addValueModal",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v("\n      Add RISC Grade Output Configuration\n    "),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-form",
                  {
                    ref: "formOutput",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.validOutput,
                      callback: function ($$v) {
                        _vm.validOutput = $$v
                      },
                      expression: "validOutput",
                    },
                  },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Code", rules: _vm.nullRule },
                      model: {
                        value: _vm.addQualifierOutput.Code,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierOutput, "Code", $$v)
                        },
                        expression: "addQualifierOutput.Code",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Description", rules: _vm.nullRule },
                      model: {
                        value: _vm.addQualifierOutput.Description,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierOutput, "Description", $$v)
                        },
                        expression: "addQualifierOutput.Description",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      attrs: { label: "Ordinal", rules: _vm.nullRule },
                      model: {
                        value: _vm.addQualifierOutput.Ordinal,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierOutput, "Ordinal", $$v)
                        },
                        expression: "addQualifierOutput.Ordinal",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        label: "Value",
                        items: _vm.allValueItem,
                        multiple: "",
                        rules: _vm.nullRuleSelect,
                      },
                      model: {
                        value: _vm.addQualifierOutput.Values,
                        callback: function ($$v) {
                          _vm.$set(_vm.addQualifierOutput, "Values", $$v)
                        },
                        expression: "addQualifierOutput.Values",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.submitAddOutput()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.addOutputModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addOutputModal,
          callback: function ($$v) {
            _vm.addOutputModal = $$v
          },
          expression: "addOutputModal",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n      Edit Qualifier Value\n    ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("v-text-field", {
                  attrs: { label: "Qualifier Value" },
                  model: {
                    value: _vm.editQualifierValue.QualifierValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierValue, "QualifierValue", $$v)
                    },
                    expression: "editQualifierValue.QualifierValue",
                  },
                }),
                _vm._v("\n      Should Filter out:\n      "),
                _c(
                  "v-menu",
                  {
                    attrs: {
                      "offset-y": "",
                      "open-on-hover": "",
                      "open-delay": 400,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-icon",
                              _vm._g(
                                {
                                  staticClass: "clickable ml-2",
                                  attrs: { small: "", color: "primary" },
                                },
                                on
                              ),
                              [_vm._v("info_outline")]
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "v-card",
                      [
                        _c("v-card-text", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ContinuousDataQualifiersManage.menuTextYes"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("v-card-text", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ContinuousDataQualifiersManage.menuTextNo"
                              )
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-switch", {
                  attrs: {
                    "hide-details": "",
                    label: `${_vm
                      .getFilterString(_vm.editQualifierValue.ShouldFilter)
                      .toString()}`,
                  },
                  model: {
                    value: _vm.editQualifierValue.ShouldFilter,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierValue, "ShouldFilter", $$v)
                    },
                    expression: "editQualifierValue.ShouldFilter",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Level", rules: _vm.qualifierValueRule },
                  model: {
                    value: _vm.editQualifierValue.Level,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierValue, "Level", $$v)
                    },
                    expression: "editQualifierValue.Level",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.submitEditValue()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.editValueModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.editValueModal,
          callback: function ($$v) {
            _vm.editValueModal = $$v
          },
          expression: "editValueModal",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v("\n      Edit RISC Grade Output Configuration\n    "),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("v-text-field", {
                  attrs: { label: "Code", rules: _vm.nullRule },
                  model: {
                    value: _vm.editQualifierOutput.Code,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierOutput, "Code", $$v)
                    },
                    expression: "editQualifierOutput.Code",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Description", rules: _vm.nullRule },
                  model: {
                    value: _vm.editQualifierOutput.Description,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierOutput, "Description", $$v)
                    },
                    expression: "editQualifierOutput.Description",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Ordinal", rules: _vm.nullRule },
                  model: {
                    value: _vm.editQualifierOutput.Ordinal,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierOutput, "Ordinal", $$v)
                    },
                    expression: "editQualifierOutput.Ordinal",
                  },
                }),
                _vm._v(" "),
                _c("v-select", {
                  attrs: {
                    label: "Value",
                    items: _vm.editOutputValueItem,
                    multiple: "",
                  },
                  model: {
                    value: _vm.editQualifierOutput.Values,
                    callback: function ($$v) {
                      _vm.$set(_vm.editQualifierOutput, "Values", $$v)
                    },
                    expression: "editQualifierOutput.Values",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    on: {
                      click: function ($event) {
                        return _vm.submitEditOutput()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.editOutputModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.editOutputModal,
          callback: function ($$v) {
            _vm.editOutputModal = $$v
          },
          expression: "editOutputModal",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n      Delete Qualifier Value\n    ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _vm._v(
                  "\n      Are you sure you want to delete qualifier value " +
                    _vm._s(_vm.deleteValueName) +
                    "? If removed, data will not be recoverable.\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { dark: "", color: "delete" },
                    on: {
                      click: function ($event) {
                        return _vm.submitDeleteValue()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("delete_forever")]),
                    _vm._v(_vm._s(_vm.$t("Button.Delete")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.deleteValueModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.deleteValueModal,
          callback: function ($$v) {
            _vm.deleteValueModal = $$v
          },
          expression: "deleteValueModal",
        },
      }),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { "max-width": "800", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v("\n      Delete RISC Grade Output Configuration\n    "),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _vm._v(
                  "\n      Are you sure you want to delete RISC grade output configuration " +
                    _vm._s(_vm.deleteOutputName) +
                    "? If removed, data will not be recoverable.\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { dark: "", color: "delete" },
                    on: {
                      click: function ($event) {
                        return _vm.submitDeleteOutput()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("delete_forever")]),
                    _vm._v(_vm._s(_vm.$t("Button.Delete")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.deleteOutputModal = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.deleteOutputModal,
          callback: function ($$v) {
            _vm.deleteOutputModal = $$v
          },
          expression: "deleteOutputModal",
        },
      }),
      _vm._v(" "),
      _c("app-confirmation-modal", {
        attrs: { "max-width": "500", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n      " + _vm._s(_vm.errorTitle) + "\n    ")]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        _vm.warningModel = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.warningModel,
          callback: function ($$v) {
            _vm.warningModel = $$v
          },
          expression: "warningModel",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }